import ajax from "../helpers/ajax";
import StoreContainer from "../stores/StoreContainer";
import { AddConversionModel } from "../types";

class ConversionService {
  static async addConversion(
    siteId: number,
    data: AddConversionModel
  ): Promise<any> {
    return await ajax({
      url: `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${siteId}/visitor/conversion`,
      method: "post",
      data: data
    });
  }
}

export default ConversionService;
